import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal } from 'components/layout'
import { SignOffForm } from 'components/forms'
import { AssessorReport } from 'containers/sections/assessors'
import { form } from 'helpers/decorators'
import validate from './signoff.validate'
import { apiAssessors } from 'helpers/decorators/api'

@apiAssessors()
@form({
  form: 'assessmentSignOff',
  disableHook: true,
  validate
})
class SignOff extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    onSignOff: PropTypes.func,
    reset: PropTypes.func,
    activitySection: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    actionId: PropTypes.number,
    colorClass: PropTypes.string,
    modalId: PropTypes.string,
    submitting: PropTypes.bool,
    isAjRequest: PropTypes.bool,
    isActivityRequest: PropTypes.bool,
    isRpRequest: PropTypes.bool,
    isAssessorReportAdditionalInfoEnabled:PropTypes.bool
  }

  state = {
    isRejecting: false
  }

  handleSignOff = (fields, { approved = true } = {}) => {
    const { onSignOff, id, activitySection } = this.props

    return onSignOff(fields, { approved, activityId: id, activitySection })
  }

  handleReject = fields => this.handleSignOff(fields, { approved: false })

  handleWantReject = () =>
    this.setState({
      isRejecting: true
    })

  handleOnClose = () => {
    this.props.reset()
    this.setState({
      isRejecting: false
    })
  }

  render() {
    const {
      modalId,
      colorClass,
      handleSubmit,
      submitting,
      id,
      actionId,
      isAjRequest,
      isActivityRequest,
      isRpRequest,
      isAssessorReportAdditionalInfoEnabled
    } = this.props

    const { isRejecting } = this.state

    return (
      <MaterialModal.Body
        id={modalId}
        title="Sign off"
        titleKey="moduleTitle.sign_off"
        colorClass={colorClass}
        onClose={this.handleOnClose}
      >
        <form
          onSubmit={handleSubmit(
            fields =>
              isRejecting
                ? this.handleReject(fields, false)
                : this.handleSignOff(fields, true)
          )}
        >
          <MaterialModal.Content>
            <AssessorReport
              id={id}
              actionId={actionId}
              isAjRequest={isAjRequest}
              isActivityRequest={isActivityRequest}
              isRpRequest={isRpRequest}
            />
            <SignOffForm
              onReject={this.handleWantReject}
              isRejecting={isRejecting}
              isAssessorReportAdditionalInfoEnabled={isAssessorReportAdditionalInfoEnabled}
              {...this.props}
            />
          </MaterialModal.Content>

          <MaterialModal.Footer
            action="Send"
            actionKey={isRejecting ? 'button.reject' : 'button.send'}
            colorClass={colorClass}
            isLoading={submitting}
          />
        </form>
      </MaterialModal.Body>
    )
  }
}

export default SignOff
